import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  IconButton,
  TableHead,
  Modal,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  Card,
} from "@mui/material";
import UserImg from "../../common/assests/sampleuser.svg";
import ReyLeaf from "../../common/assests/reyleafLogo.svg";
import Adminimg from "../../common/assests/adminimg.png";
import CrossIcon from "../../common/assests/croosicon.png";
import SearchItem from "../../common/assests/search.svg";
import Paginations from "../../common/pagination/Paginations";
import "./Orders.css";
import { useSelector } from "react-redux";
import TableComp from "../../common/tablecomp/TableComp";
import OrderManagementRow from "../../common/tablerow/OrderManagementRow";
import {
  allOrderManagementApi,
  OrderDetailsApi,
  orderStatusApi,
} from "../../api";
import Loader from "../../common/loader/Loader";
import { toast } from "react-toastify";
import OrderProductManagementRow from "../../common/tablerow/OrderProductManagementRow";
import configuration from "../../config/Config";

const Orders = () => {

  const token = useSelector((state) => state?.user?.user?.token);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [orderManagementData, setOrderManagementData] = useState([]);
  const [orderDetailsData, setOrderDetailsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [myTimout, setMyTimeOut] = useState();
  const [status, setStatus] = useState("");
  const [change, setChange] = useState(false);


  const handleOrderManagementApi = async () => {
    try {
      setLoading(true);
      const response = await allOrderManagementApi({
        token,
        searchQuery,
        currentPage,
      });
      // console.log("order management response",response.data);
      setOrderManagementData(response?.data?.orders || []);
      setCurrentPage(response?.data?.currentPage);
      setTotalPages(response?.data?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
    }
  };

  useEffect(() => {
    // if(currentPage>)
    handleOrderManagementApi();
  }, [currentPage, change]);

  useEffect(() => {
    // if(searchQuery=="") return;

    
    if (searchQuery.trim() == "") {
  
      handleOrderManagementApi();
    } else {

      clearTimeout(myTimout);
      const timeout = setTimeout(() => handleOrderManagementApi(), 500);
      setMyTimeOut(timeout);

      // Cleanup on unmount or re-render
      return () => clearTimeout(timeout);
    }
  }, [searchQuery]);
  
  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //   clearTimeout(myTimout);
  //   setMyTimeOut(setTimeout(handleOrderManagementApi, 500));
  // }
  // }, [searchQuery]);

  const handleOrderDetails = async (id) => {
    try {
      const response = await OrderDetailsApi({ token, id });
      setOrderDetailsData(response);

      // setCurrentPage(response?.data?.currentPage)
      // setTotalPages(response?.data?.totalPages)
    } catch (error) {
      console.log("error", error);
    }
  };


  const handleStatusUpdate = async (status, id) => {
    const isConfirmed = window.confirm(
      "Are you sure, you want to Change this Status?"
    );
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await orderStatusApi({ token, status, id });
      toast.success(response?.message);
      setChange(!change);
    } catch (error) {
      if (error?.status === 500) {
        toast.error("Some error occured");
      } else {
        toast.error(error?.message);
      }
      console.log("error", error);
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };
  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setStatus(row?.status || "");
    setOpen(true);
    handleOrderDetails(row?._id);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const titles = [
    { title: "Order By" },
    { title: "Business Name" },
    { title: "Address" },
    { title: "Total Price" },
    { title: " Quantity" },
    { title: "Payment Status" },
    { title: "Order Status" },
    { title: " Action" },
  ];

  const titles1 = [
    { title: "Image" },
    { title: "Product Name" },
    { title: "Category" },
    { title: "Quantity" },
    { title: "Regular Price" },
    { title: "Item Total" },
    { title: "Discounted Price" },
  ];

  return (
    <div>
      {loading ? (
        <Loader variant="table" />
      ) : (
        <>
          <Card
            backgroundColor={"#fff"}
            borderRadius={"35px"}
            w={"100%"}
            h={"auto"}
            sx={{ padding: "20px", borderRadius: "25px" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                flexWrap:'wrap'
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontWeight: "600", color: "#362B24" }}
              >
                Order List
              </Typography>
              <TextField
                autoFocus
                value={searchQuery}
                onChange={(e) => {
                  if (e.target.value.trim() !== "" || e.target.value === "") {
                    setSearchQuery(e.target.value);
                  }
                }}
                placeholder="Search by order status"
                sx={{
                  width: { xs: 240},
                  height: { xs: 48},
                  flexShrink: 0,
                  borderRadius: "33px",
                  background: "#EBEBEB",
                  border: "none",
                  "& .MuiOutlinedInput-input": {
                      height: "30%",
                    },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "33px",
                    height: "100%",
                    paddingRight: "10px",
                    outline: "none",
                    border: "none",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={SearchItem}
                        sx={{ color: "#000", opacity: "0.35" }}
                      />
                    </InputAdornment>
                  ),
                  style: { height: "100%" },
                }}
              />
            </Box>

            <TableComp title={titles} emptyEColumnCount={1}>
              {orderManagementData.length > 0 ? (
                orderManagementData.map((item) => (
                  <OrderManagementRow
                    key={item?._id}
                    rows={item}
                    handleModal={() => handleClickOpen(item)}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={titles.length} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableComp>
            <Paginations
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                disabled={loading}
              />
          </Card>

          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                maxHeight: "70vh",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                // maxWidth: "874px",
                maxWidth: "720px",
                width: "90%",
                bgcolor: "#F5F5F5",
                borderRadius: "32px",
                boxShadow: 24,

                overflowY: "auto",
                p: 4,
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "@media (min-width: 1600px)": {
                  width: "90vw",
                },
                "@media (max-width: 1400px)": {
                  width: "80vw",
                },
                "@media (max-width: 1200px)": {
                  width: "60vw",
                },
                "@media (max-width: 1024px)": {
                  width: "60vw",
                },
                "@media (max-width: 767px)": {
                  width: "80vw",
                },
                "@media (max-width: 576px)": {
                  width: "90vw",
                },
                "@media (max-width: 480px)": {
                  width: "95vw",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "16px",
                    color: "#362B24",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  Order Details
                </Typography>

                <IconButton>
                  <img
                    src={CrossIcon}
                    alt="img"
                    onClick={handleClose}
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                </IconButton>
              </Box>
              {selectedRow && (
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#362B24",
                        }}
                      >
                        Order By
                      </Typography>
                      <Typography sx={{ marginTop: "15px" }}>
                        <img
                          src={
                            selectedRow?.user?.picture
                              ? `${configuration.cdnFront}/${selectedRow?.user?.picture}`
                              : UserImg
                          }
                          alt="User"
                          style={{
                            width: "42px",
                            height: "42px",
                            marginRight: "5px",
                            borderRadius: "25px",
                          }}
                        />
                        <strong> {selectedRow?.user?.fullname || "-"}</strong>
                      </Typography>
                    </Box>
                  </Box>
                  <br />
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(120px, 1fr))",
                      gap: "18px",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Order Date
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>
                          {" "}
                          {selectedRow?.createdAt
                            ? new Date(
                                selectedRow.createdAt
                              ).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              })
                            : "-"}
                        </strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Order ID
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>{selectedRow?.orderId || "-"}</strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Quantity
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>
                          {selectedRow?.items?.reduce(
                            (total, item) => total + (item?.quantity || 0),
                            0
                          )}
                        </strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                          fontSize: "15px",
                        }}
                      >
                        Payment Status
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>{selectedRow?.paymentStatus || "-"}</strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Card
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>{selectedRow?.card || "-"}</strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Total Price
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>{`$${
                          selectedRow?.totalAmount
                            ? selectedRow?.totalAmount
                            : "-"
                        }`}</strong>
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(120px, 1fr))",

                      marginTop: "40px",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Shipping Address
                      </Typography>
                      <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                        <strong>
                          {" "}
                          {selectedRow?.address
                            ? [
                                selectedRow.address.address || "",
                                selectedRow.address.city || "",
                                selectedRow.address.state || "",
                                selectedRow.address.country || "",
                                selectedRow.address.zipcode || "",
                              ]
                                .filter(Boolean)
                                .join(", ")
                            : "-"}
                        </strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          opacity: "0.6",
                          color: "#362B24",
                        }}
                      >
                        Seller Name
                      </Typography>
                      <Typography variant="body2" sx={{ marginTop: "8px" }}>
                        <img
                          src={
                            selectedRow?.seller?.picture
                              ? `${configuration.cdnFront}/${selectedRow?.seller?.picture}`
                              : ReyLeaf
                          }
                          alt="User"
                          style={{
                            width: "42px",
                            height: "42px",
                            marginRight: "5px",
                            borderRadius: "25px",
                          }}
                        />
                        <strong> {selectedRow?.seller?.fullname || "-"}</strong>
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: { xs: "wrap", sm: "nowrap" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "400",
                          color: "#362B24",
                          marginBottom: { xs: "10px", sm: "0" },
                        }}
                      >
                        Order Status
                      </Typography>

                      <Select
                        defaultValue="Dispatched"
                        value={status}
                        onChange={(e) => {
                          setStatus(e.target.value);
                          handleStatusUpdate(e.target.value, selectedRow?._id);
                          handleClose();
                        }}
                        sx={{
                          width: 164,
                          height: 49,
                          borderRadius: 28,
                          border: "1px solid #362B24",
                          bgcolor: "none",
                          marginLeft: { sm: "10px", xs: "0" },
                          color: "#000",
                          fontWeight: "400",

                          display: "block",
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              borderRadius: "10px",
                              border: "1px solid #E8E8E8",
                              backgroundColor: "#EFEFEF",
                            },
                          },
                        }}
                      >
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="accepted">Accepted</MenuItem>
                        <MenuItem value="declined">Declined</MenuItem>
                        <MenuItem value="packed">Packed</MenuItem>
                        <MenuItem value="dispatched">Dispatched</MenuItem>
                        <MenuItem value="completed">Completed</MenuItem>
                        <MenuItem value="cancelled">Cancelled</MenuItem>
                      </Select>
                    </Box>
                  </Box>

                  <Card
                    backgroundColor={"#fff"}
                    borderRadius={"35px"}
                    w={"100%"}
                    h={"auto"}
                    sx={{
                      padding: "20px",
                      borderRadius: "25px",
                      marginTop: "20px",
                    }}
                  >
                    <TableComp title={titles1}>
                      {orderDetailsData?.items &&
                      orderDetailsData.items.length > 0 ? (
                        orderDetailsData.items.map((item) => (
                          <OrderProductManagementRow
                            key={item._id}
                            rows={item}
                          />
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={titles1.length} align="center">
                            No Data Found
                          </TableCell>
                        </TableRow>
                      )}

                      {/* <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
            /> */}
                    </TableComp>
                  </Card>
                </Box>
              )}
            </Box>
          </Modal>
        </>
      )}
    </div>
  );
};

export default Orders;
